import { useDwellTime } from '@confluence/dwell';

type ContentTypeDwellTimeComponentProps = {
	contentType: string | null | undefined;
	contentId: string;
	spaceId: string | null | undefined;
	contentReferenceId?: string | null | undefined;
	searchSessionId: string | null | undefined;
	spaceType: string | null | undefined;
	isUserViewingOwnPersonalSpace: boolean;
	customAttributes?: {};
	iframeDwell?: boolean;
};

export const ContentTypeDwellTimeComponent = ({
	contentType,
	contentId,
	spaceId,
	contentReferenceId,
	searchSessionId,
	spaceType,
	isUserViewingOwnPersonalSpace,
	customAttributes,
	iframeDwell,
}: ContentTypeDwellTimeComponentProps) => {
	const isEmbed = contentType === 'embed';

	useDwellTime(
		{
			source: contentType,
			objectType: contentType,
			objectId: contentId,
			actionSubject: contentType,
			containerType: 'space',
			containerId: spaceId,
			...(!isEmbed ? { actionSubjectId: contentReferenceId } : {}),
			attributes: {
				searchReferrer: searchSessionId,
				pageType: contentType,
				spaceType,
				isUserViewingOwnPersonalSpace,
				...customAttributes,
			},
		},
		iframeDwell,
	);

	return null;
};
